(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["the-olfactive-guide"] && !Shopify.designMode) return;
  try {
    
(function () {

  var FAMILIES = [
    { id: 'leather',   label: 'Leather',    hint: 'Suede, smoked leather, animalic' },
    { id: 'woody',     label: 'Woody',      hint: 'Cedar, sandalwood, vetiver' },
    { id: 'floral',    label: 'Floral',     hint: 'Rose, tuberose, iris' },
    { id: 'oriental',  label: 'Oriental',   hint: 'Oud, amber, resins' },
    { id: 'spicy',     label: 'Spicy',      hint: 'Saffron, cardamom, pepper' },
    { id: 'citrus',    label: 'Citrus',     hint: 'Bergamot, neroli, zesty fruits' },
    { id: 'aromatic',  label: 'Aromatic',   hint: 'Lavender, sage, juniper' },
    { id: 'gourmand',  label: 'Gourmand',   hint: 'Tonka, vanilla, honey' },
    { id: 'green',     label: 'Green',      hint: 'Fern, moss, leaves' },
    { id: 'musky',     label: 'Musky',      hint: 'White musk, skin, ambrette' },
    { id: 'smoky',     label: 'Smoky',      hint: 'Birch, incense, tobacco' },
    { id: 'marine',    label: 'Marine',     hint: 'Sea spray, salt, seaweed' }
  ];

  // Hand-tuned affinity scores per perfume, keyed by a NORMALISED handle:
  // the product handle stripped of its "-eau-de-parfum" / "-<size>ml" suffixes
  // (e.g. "odeon-rosebud-eau-de-parfum-75ml" -> "odeon-rosebud"). Keeping the
  // short key means renaming or re-sizing a product never silently drops its
  // tuning. A perfume absent from this table falls back to an affinity
  // inferred from its notes (see inferAffinity below) — so new launches still
  // surface immediately; add an entry here only to fine-tune them.
  var AFFINITY_BY_KEY = {
    // ── Cuirs Nomades ──
    'african-leather':   { leather:9, spicy:9, floral:5, oriental:6 },
    'irish-leather':     { leather:9, aromatic:8, green:8, woody:5 },
    'irish-oud':         { leather:9, oriental:9, green:7, smoky:6, aromatic:6 },
    'italian-leather':   { leather:9, green:8, gourmand:6, smoky:5 },
    'french-leather':    { leather:8, citrus:7, floral:7, aromatic:6, green:4 },
    'iberian-leather':   { leather:8, aromatic:7, woody:7, spicy:5 },
    'ocean-leather':     { marine:9, leather:8, citrus:7, aromatic:6, woody:5 },
    'sicilian-leather':  { citrus:9, leather:8, woody:7, green:5 },
    'oriental-leather':  { leather:9, oriental:9, floral:5, woody:5 },
    'moroccan-leather':  { leather:8, floral:8, woody:6, musky:5 },
    'indian-leather':    { leather:9, oriental:9, woody:6, smoky:5, floral:4 },
    'eau-de-memo':       { floral:7, green:7, citrus:6, leather:6, musky:5 },

    // ── Fleurs Bohèmes ──
    'marfa':             { floral:10, musky:7, gourmand:6, woody:4 },
    'odeon':             { floral:9, gourmand:7, woody:6, musky:6, oriental:5 },
    'odeon-x-jean-jullien': { floral:9, gourmand:7, woody:6, musky:6, oriental:5 },
    'odeon-rosebud':     { floral:10, musky:7, gourmand:6, citrus:4 },
    'omnia-omnibus-ubique': { floral:9, oriental:8, musky:7, spicy:6, woody:5 },
    'menorca':           { citrus:9, marine:8, musky:7, floral:5, woody:4 },
    'portobello-road':   { floral:9, green:8, aromatic:6, woody:5, citrus:4 },
    'cap-camarat':       { floral:9, gourmand:8, woody:7, oriental:5 },
    'cap-camarat-x-olimpia-zagnoli': { floral:9, gourmand:8, woody:7, oriental:5 },
    'madurai':           { floral:9, spicy:7, woody:5, gourmand:5, citrus:4 },
    'inle':              { floral:9, green:7, citrus:5, musky:5, aromatic:4 },
    'sintra':            { gourmand:9, floral:8, musky:7, citrus:4 },
    'argentina':         { floral:9, musky:8, oriental:8, woody:4 },
    'ilha-do-mel':       { floral:9, aromatic:6, gourmand:5, woody:4 },
    'lalibela':          { floral:8, oriental:7, smoky:6, musky:5 },

    // ── Graines Vagabondes / Escales ──
    'ithaque':           { citrus:8, green:7, woody:7, spicy:5 },
    'zante':             { citrus:9, aromatic:8, floral:5, oriental:4 },
    'corfu':             { floral:9, green:7, musky:7, citrus:5 },
    'kedu':              { citrus:9, musky:7, gourmand:6, green:5, woody:4 },
    'flam':              { citrus:8, aromatic:8, gourmand:7, woody:5, musky:4 },
    'winter-palace':     { oriental:7, citrus:7, gourmand:7, aromatic:6, woody:5 },
    'tamarindo':         { gourmand:8, floral:8, citrus:6, oriental:5, green:4 },
    'red-island':        { gourmand:9, spicy:7, woody:6, oriental:5, floral:4 },
    'palais-bourbon':    { oriental:9, gourmand:8, spicy:8, woody:6, smoky:4 },
    'abu-dhabi':         { spicy:9, gourmand:8, woody:8, oriental:6, smoky:4 },
    'honey-dragon':      { spicy:10, gourmand:8, oriental:7, smoky:5 },
    'cappadocia':        { spicy:9, woody:8, oriental:9, smoky:4 },
    'shams-oud':         { oriental:10, spicy:7, woody:7, musky:4 },
    'moon-fever':        { citrus:7, woody:6, leather:7, musky:5 },
    'quartier-latin':    { woody:9, oriental:7, gourmand:5, musky:4 },
    'granada':           { floral:9, gourmand:6, oriental:5, musky:5 },
    'inverness':         { woody:9, floral:6, musky:6, aromatic:5 },
    'sherwood':          { woody:10, floral:5, green:5, musky:4 },
    // Darling Point — key notes: cinnamon / sweet pear / apple over a jasmine,
    // orange blossom, saffron and rose heart, on moss, cashmere wood, praline.
    // Inferred scoring only ever caught the floral heart (the guide reads the
    // first bold line of the notes, where the praline and cinnamon never
    // appear), so the gourmand and spicy sides are set by hand here.
    'darling-point':     { floral:9, gourmand:8, spicy:7, woody:5, green:4 },
    // Both Thomas Lelu editions share Darling Point's juice, hence its
    // affinity. The collapse in computeMatches hides them behind the classic
    // bottle; these entries only keep them correctly scored for the day the
    // classic 75ml leaves the collection.
    'darling-point-x-thomas-lelu-stabilo': { floral:9, gourmand:8, spicy:7, woody:5, green:4 },
    'darling-point-x-thomas-lelu-white':   { floral:9, gourmand:8, spicy:7, woody:5, green:4 },

    // ── Références présentes sur Memo US (absentes du catalogue WW) ──
    'marfa-oud':         { floral:9, oriental:9, musky:6, woody:5, gourmand:4 },
    'marfa-spices':      { floral:9, spicy:7, musky:6, woody:4 },
    'lyra-peach':        { floral:9, gourmand:7, spicy:5, woody:5 },
    'siwa':              { gourmand:9, floral:7, oriental:7, smoky:5, musky:5 },
    'african-rose':      { floral:9, leather:8, oriental:7, spicy:6, woody:4 },
    'kotor':             { gourmand:10, floral:5, leather:5, oriental:4 },
    'tigers-nest':       { oriental:8, aromatic:7, floral:6, smoky:6, gourmand:5 },
    'jannat':            { citrus:9, floral:8, spicy:6, musky:5, woody:4 },
    'luxor-oud':         { oriental:9, floral:7, citrus:6, woody:5 },
    'cassiopeia-rose':   { floral:9, gourmand:7, oriental:7, musky:6, smoky:4 },
    'russian-leather':   { leather:9, aromatic:8, green:6, woody:5, gourmand:4 },
    'moon-leather':      { leather:8, citrus:8, aromatic:7, woody:6, gourmand:4 },

    // ── Nouveautés 2026 ──
    // Adare — key notes: orange flower absolute, tuberose absolute, sandalwood.
    // Inference already catches the white floral and the sandalwood, but never
    // the vanilla, musk, ginger and citrus of the pyramid (the guide only reads
    // the first bold line of the notes), hence the hand-set entry.
    'adare':             { floral:10, woody:6, gourmand:5, musky:5, citrus:4 },
    // Cosmos — key notes: floral passionfruit, white rose, vanilla absolute.
    // There is no "fruity" family among the twelve and no passionfruit keyword,
    // so inference only ever caught the rose and the vanilla: without this entry
    // the perfume stays invisible on nearly every family combination.
    'cosmos':            { floral:9, gourmand:8, woody:6, spicy:5, citrus:5 },
    // West 34 (Macy's exclusive) - key notes: bergamot essence, jasmine absolute,
    // white musk. Inference catches all three, but as a new launch it loses every
    // tie to the best sellers; the entry also adds the sandalwood and peach of
    // the pyramid.
    'west-34':           { floral:9, musky:7, citrus:6, woody:5, gourmand:3 }
  };

  // Strip the marketing suffixes Shopify handles carry so the table above can
  // be keyed on the perfume itself:
  //   "odeon-rosebud-eau-de-parfum-75ml" -> "odeon-rosebud"
  //   "eau-de-memo-parfum-100ml"         -> "eau-de-memo"
  function affinityKey(handle) {
    return String(handle || '')
      .toLowerCase()
      .replace(/-\d+\s*ml$/, '')
      .replace(/-eau-de-parfum$/, '')
      .replace(/-parfum$/, '')
      .replace(/-nok$/, '');
  }

  // Keyword tables (FR + EN) used to infer family affinity from a perfume's
  // notes string when no explicit affinity is set for its handle. Adding a
  // new perfume to the collection? It auto-scores via these keywords.
  var FAMILY_KEYWORDS = {
    leather:  ['cuir', 'leather', 'su\u00e8de', 'suede', 'daim'],
    woody:    ['bois', 'wood', 'c\u00e8dre', 'cedar', 'santal', 'sandalwood', 'v\u00e9tiver', 'vetiver', 'amyris', 'cypriol'],
    floral:   ['rose', 'jasmin', 'jasmine', 'fleur', 'flower', 'tub\u00e9reuse', 'tuberose', 'iris', 'gard\u00e9nia', 'gardenia', 'osmanthus', 'oranger', 'blossom'],
    oriental: ['oud', 'ambre', 'amber', 'r\u00e9sine', 'resin', 'encens', 'incense', 'patchouli'],
    spicy:    ['poivre', 'pepper', 'cardamome', 'cardamom', 'safran', 'saffron', 'cannelle', 'cinnamon', 'gingembre', 'ginger', 'coriandre', 'coriander'],
    citrus:   ['citron', 'lime', 'lemon', 'bergamote', 'bergamot', 'mandarine', 'mandarin', 'pamplemousse', 'grapefruit', 'n\u00e9roli', 'neroli', 'c\u00e9drat', 'cedrat'],
    aromatic: ['lavande', 'lavender', 'sauge', 'sage', 'geni\u00e8vre', 'genevrier', 'juniper', 'mat\u00e9', 'mate', 'sclar\u00e9e', 'clary'],
    gourmand: ['vanille', 'vanilla', 'tonka', 'miel', 'honey', 's\u00e9same', 'sesame', 'datte', 'date', 'cashmeran', 'p\u00eache', 'peach'],
    green:    ['vert', 'green', 'feuille', 'leaf', 'mousse', 'moss', 'foug\u00e8re', 'fern', 'galbanum', 'foin', 'tomate', 'tomato'],
    musky:    ['musc', 'musk', 'ambrette'],
    smoky:    ['bouleau', 'birch', 'tabac', 'tobacco', 'fum\u00e9', 'smoky', 'myrrhe', 'myrrh'],
    marine:   ['marin', 'marine', 'mer', 'sea', 'salt', 'sel', 'algue', 'seaweed', 'embrun']
  };

  function inferAffinity(notes) {
    var s = String(notes || '').toLowerCase();
    var aff = {};
    Object.keys(FAMILY_KEYWORDS).forEach(function (fam) {
      var hits = 0;
      FAMILY_KEYWORDS[fam].forEach(function (kw) {
        if (s.indexOf(kw) !== -1) hits++;
      });
      if (hits > 0) aff[fam] = Math.min(10, 4 + hits * 3);
    });
    // If nothing matched, give a flat baseline so the perfume can still surface
    if (Object.keys(aff).length === 0) {
      aff = { floral:3, woody:3, citrus:3, oriental:3, spicy:3, gourmand:3 };
    }
    return aff;
  }

  // Build a perfume entry from one product in the collection JSON. Affinity
  // comes from AFFINITY_BY_HANDLE if set (precise), else inferred from notes.
  function buildPerfume(handle, p) {
    return {
      handle: handle,
      name: (p.title || handle).toUpperCase(),
      tagline: p.tagline || '',
      notes: p.notes || '',
      affinity: AFFINITY_BY_KEY[affinityKey(handle)] || inferAffinity(p.notes),
      // `rank` mirrors the collection iteration order. The merchant should
      // set the perfumes collection sort to "Best selling" in Shopify Admin
      // so this lines up with sales velocity. Used as the primary tiebreaker
      // in computeMatches so bestsellers surface first when scores tie.
      rank: typeof p.rank === 'number' ? p.rank : 9999
    };
  }

  function buildPerfumesFromProducts(products) {
    if (!products) return [];
    var list = [];
    Object.keys(products).forEach(function (handle) {
      list.push(buildPerfume(handle, products[handle] || {}));
    });
    return list;
  }

  var ICONS = {
    leather:  '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6c3-2 7-2 10-1s4 4 3 7-5 5-9 4S1 12 3 6z"/><path d="M7 9c1-.5 2-.5 3 0M10 12c1-.3 2-.3 3 .2"/></svg>',
    woody:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v16M10 6l-4-3M10 9l4-3M10 12l-4-3M10 15l4-3"/></svg>',
    floral:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="2"/><path d="M10 8V4M10 12v4M8 10H4M12 10h4M7 7L4.5 4.5M13 7l2.5-2.5M7 13l-2.5 2.5M13 13l2.5 2.5"/></svg>',
    oriental: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16c0-4 3-7 6-7s6 3 6 7"/><path d="M10 9V3M8 5l2-2 2 2"/><circle cx="10" cy="14" r="1"/></svg>',
    spicy:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5s1 3 4 4 6 0 6 0-1 3-4 5-8 2-9-1 0-6 3-8z"/></svg>',
    citrus:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="6"/><path d="M10 4v12M4 10h12M6 6l8 8M14 6l-8 8"/></svg>',
    aromatic: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17V7c0-2 1-3 3-3s3 1 3 3"/><path d="M10 11c-3 0-5-1-5-4M10 14c-3 0-5-1-5-4"/></svg>',
    gourmand: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10c0-3 3-6 6-6s6 3 6 6v1c0 3-2 5-6 5s-6-2-6-5z"/><path d="M7 10c1 1 2 1 3 0M10 10c1 1 2 1 3 0"/></svg>',
    green:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17C10 11 5 7 3 6c0 6 3 11 7 11z"/><path d="M10 17c0-6 5-10 7-11 0 6-3 11-7 11z"/></svg>',
    musky:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="5"/><circle cx="10" cy="10" r="2"/><path d="M10 3v2M10 15v2M3 10h2M15 10h2"/></svg>',
    smoky:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7c2-2 5-1 6 1s4 2 6 0M4 11c2-2 5-1 6 1s4 2 6 0M4 15c2-2 5-1 6 1"/></svg>',
    marine:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/><path d="M3 12c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/><path d="M3 16c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/></svg>'
  };

  var ARROW = '<svg class="ff-btn-arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>';
  var CHECK = '<svg class="ff-card-check-icon" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5L5 9l4.5-5.5"/></svg>';

  function computeMatches(selected, topN, perfumes) {
    if (!selected.length) return [];
    var src = perfumes || [];
    var scored = src.map(function (p) {
      var raw = 0;
      selected.forEach(function (id) { raw += (p.affinity[id] || 0); });
      return { handle: p.handle, name: p.name, tagline: p.tagline, notes: p.notes, score: raw, rank: p.rank };
    });
    // Sort: best score first, bestseller rank as tiebreaker, then alpha.
    scored.sort(function (a, b) {
      return b.score - a.score
          || (a.rank || 9999) - (b.rank || 9999)
          || a.name.localeCompare(b.name);
    });
    // Never surface a perfume with zero affinity for what was selected: the
    // 42% floor below would dress it up as a plausible match. Showing two
    // honest results beats three with a filler.
    scored = scored.filter(function (s) { return s.score > 0; });
    if (!scored.length) return [];
    // Collapse artist editions onto their parent scent ("CAP CAMARAT X OLIMPIA
    // ZAGNOLI" shares Cap Camarat's juice, and therefore its affinity), so the
    // same fragrance can't take two of the three slots. The classic bottle
    // always wins the slot when it is a match too: the artist editions are
    // limited runs, so sending someone who has just discovered the scent to
    // one of them points at a bottle that may already be gone. An edition
    // still shows when it is the only match left (classic sold out or pulled
    // from the collection).
    var pickByScent = {};
    scored.forEach(function (s) {
      var full = String(s.name || '').toLowerCase().trim();
      s.scent = full.split(/\s+x\s+/)[0].trim();
      s.isEdition = s.scent !== full;
      var kept = pickByScent[s.scent];
      // `scored` is already sorted by score then bestseller rank, so the first
      // entry seen for a scent is its best; only an edition can be displaced,
      // and only by a classic bottle.
      if (!kept || (kept.isEdition && !s.isEdition)) pickByScent[s.scent] = s;
    });
    scored = scored.filter(function (s) { return pickByScent[s.scent] === s; });
    var best = scored[0].score;
    var targetTop = 88 + Math.floor(Math.random() * 10);
    scored.forEach(function (s) {
      s.match = best > 0 ? Math.max(42, Math.round((s.score / best) * targetTop)) : 0;
    });
    return scored.slice(0, topN);
  }

  function bottleHTML(p, products) {
    var pd = products[p.handle];
    if (pd && pd.image) {
      return '<img decoding="async" src="' + pd.image + '" alt="' + p.name + '" loading="lazy">';
    }
    return '<div class="ff-bottle-placeholder"><div class="ff-bottle-cap"></div><div class="ff-bottle-body"><div class="ff-bottle-brand">MEMO</div><div class="ff-bottle-name">' + p.name + '</div></div></div>';
  }

  function resultRowHTML(p, rank, products, showMatch, t) {
    var pd = products[p.handle];
    var url = (pd && pd.url) ? pd.url : ('/products/' + p.handle);
    var matchHTML = showMatch
      ? '<div class="ff-result-match">' +
          '<div class="ff-result-pct">' + p.match + '%</div>' +
          '<div class="ff-result-pct-label">' + ((t && t.match) || 'Match') + '</div>' +
          '<div class="ff-result-bar"><div class="ff-result-bar-fill" style="width:' + p.match + '%"></div></div>' +
        '</div>'
      : '';
    return '<a class="ff-result-row' + (rank === 0 ? ' is-top' : '') + (showMatch ? '' : ' ff-no-match') + '" href="' + url + '">' +
      '<div class="ff-bottle">' + bottleHTML(p, products) + '</div>' +
      '<div class="ff-result-meta">' +
        '<div class="ff-result-coll">' + p.tagline + '</div>' +
        '<div class="ff-result-name">' + p.name + '</div>' +
        '<div class="ff-result-notes">' + p.notes.split('\u00b7').map(function(s){ return '<span class="ff-note-item">' + s.trim() + '</span>'; }).join('') + '</div>' +
      '</div>' +
      matchHTML +
    '</a>';
  }

  function quizHTML(overline, heading, description, selected, families, t) {
    var count = selected.length;
    return '<div class="ff-overline">' + overline + '</div>' +
      '<h2 class="ff-title">' + heading + '</h2>' +
      '<div class="ff-lede">' + description + '</div>' +
      '<p class="ff-step">' + t.multipleChoices + '</p>' +
      '<div class="ff-cards">' +
        families.map(function (f) {
          var on = selected.indexOf(f.id) !== -1;
          var iconSvg = ICONS[f.id] || '';
          return '<button class="ff-card' + (on ? ' is-on' : '') + '" type="button" aria-pressed="' + on + '" data-family-id="' + f.id + '">' +
            '<span class="ff-card-check">' + CHECK + '</span>' +
            '<span class="ff-card-symbol">' + iconSvg + '</span>' +
            '<div class="ff-card-label">' + f.label + '</div>' +
            '<div class="ff-card-hint">' + f.hint.split(',').map(function(s){ var x = s.trim(); return '<span class="ff-hint-item">' + x.charAt(0).toUpperCase() + x.slice(1) + '</span>'; }).join('') + '</div>' +
          '</button>';
        }).join('') +
      '</div>' +
      '<div class="ff-actions">' +
        '<div class="ff-count"><strong>' + count + '</strong> ' + (count === 1 ? t.familySingular : t.familyPlural) + '</div>' +
        '<button class="ff-btn ff-btn-circle" type="button" data-ff-submit' + (count === 0 ? ' disabled' : '') + ' aria-label="' + t.revealAria + '">' + ARROW + '</button>' +
      '</div>';
  }

  function resultsHTML(overline, selected, matches, ctaUrl, ctaLabel, products, compact, resultsHeading, restartLabel, resultsNote, families, t) {
    var labels = selected.map(function (id) {
      var f = families.filter(function (x) { return x.id === id; })[0];
      return f ? f.label.toLowerCase() : '';
    }).filter(Boolean);
    var subtitle = compact ? '' : ('<em>' + t.forPreposition + ' ' + labels.slice(0, 3).join(' \u00b7 ') + (labels.length > 3 ? '\u2026' : '') + '</em>');
    // A narrow selection can legitimately return fewer than three perfumes
    // (only two are marine, for instance). Keep the merchant's wording but
    // match the real count, in whatever language the heading is written:
    // "Your 3 perfumes" / "Vos 3 parfums" -> "... 2 ...".
    if (matches.length && matches.length !== 3) {
      resultsHeading = String(resultsHeading).replace(/\b3\b/, String(matches.length));
    }
    var showMatch = matches.length > 1 && !matches.every(function(m) { return m.match === matches[0].match; });
    var topMatch = matches[0];
    var topUrl = ctaUrl ||
      (topMatch && products[topMatch.handle] && products[topMatch.handle].url) ||
      (topMatch ? '/products/' + topMatch.handle : '/collections/perfumes');
    return '<div class="ff-results-head">' +
        '<div><div class="ff-overline">' + overline + '</div><h2 class="ff-title">' + resultsHeading + subtitle + '</h2></div>' +
      '</div>' +
      '<div class="ff-result-list">' + matches.map(function (p, i) { return resultRowHTML(p, i, products, showMatch, t); }).join('') + '</div>' +
      '<div class="ff-results-foot">' +
        '<div class="ff-results-note">' + resultsNote + '</div>' +
        '<button class="ff-restart" type="button" data-ff-restart><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg><span class="ff-restart-text">' + restartLabel + '</span></button>' +
      '</div>';
  }

  /* ── Email capture ─────────────────────────────────────────────
     Sends the result set to Klaviyo from the browser with the public
     API key: one subscription (list + profile custom properties) and
     one custom event that carries the perfumes, so the recap flow can
     be triggered even for people already on the list.
  ────────────────────────────────────────────────────────────────── */
  var KLAVIYO_REVISION = '2024-02-15';
  var KLAVIYO_METRIC   = 'Olfactive Guide Results';

  function emailBlockHTML(t) {
    var e = (t && t.email) || {};
    var title       = e.title       || 'Receive your results by email';
    var text        = e.text        || 'We send this selection straight to your inbox, so your three fragrances stay with you.';
    var placeholder = e.placeholder || 'Your email address';
    var button      = e.button      || 'Send me my results';
    var consent     = e.consent     || '';
    return '<div class="ff-email" data-ff-email>' +
        '<div class="ff-email-copy">' +
          '<div class="ff-email-title">' + title + '</div>' +
          '<p class="ff-email-text">' + text + '</p>' +
        '</div>' +
        '<div class="ff-email-action">' +
          '<form class="ff-email-form" novalidate>' +
            '<input class="ff-email-input" type="email" name="email" autocomplete="email" inputmode="email" placeholder="' + placeholder + '" aria-label="' + placeholder + '" required>' +
            '<button class="ff-email-btn" type="submit">' + button + '</button>' +
          '</form>' +
          (consent ? '<p class="ff-email-consent">' + consent + '</p>' : '') +
          '<p class="ff-email-msg" hidden></p>' +
        '</div>' +
      '</div>';
  }

  function absoluteUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.indexOf('http') === 0) return u;
    return window.location.origin + u;
  }

  function klaviyoPost(path, company, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    });
  }

  function sendResultsToKlaviyo(cfg, email, perfumes, families) {
    var names = perfumes.map(function (p) { return p.name; });
    var profileProps = {
      // NB: named "Guide Source" and not "Source" so it never shadows
      // Klaviyo's built-in $source (which custom_source below already sets)
      // in the flow-condition picker.
      'Guide Source': cfg.source,
      'Guide': cfg.guide,
      'Guide Language': cfg.lang,
      'Guide Perfume': names[0] || '',
      'Guide Perfumes': names.join(', '),
      'Guide Families': families.join(', '),
      'Guide Completed At': new Date().toISOString()
    };
    var subscription = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: profileProps }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    var event = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            'Source': cfg.source,
            'Guide': cfg.guide,
            'Language': cfg.lang,
            'Families': families.join(', '),
            'PerfumeNames': names.join(', '),
            'TopPerfume': names[0] || '',
            'TopPerfumeUrl': perfumes[0] ? perfumes[0].url : '',
            'Perfumes': perfumes
          },
          metric: { data: { type: 'metric', attributes: { name: KLAVIYO_METRIC } } },
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: profileProps }
            }
          }
        }
      }
    };
    return klaviyoPost('subscriptions', cfg.company, subscription).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('subscription ' + res.status);
      return klaviyoPost('events', cfg.company, event);
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('event ' + res.status);
      return true;
    });
  }

  function placeholderHTML() {
    return '<div class="ff-b-placeholder">' +
      '<div class="ff-b-placeholder-mark">MEMO<small>PARIS</small></div>' +
      '<div class="ff-b-placeholder-label">\u2014 Your sillage \u2014</div>' +
      '<p class="ff-b-placeholder-text">Your three fragrances will appear here, ranked by olfactory affinity.</p>' +
    '</div>';
  }

  function FragranceFinder(root) {
    var el = this;
    el.root     = root;
    el.variant  = root.dataset.variant  || 'a';
    el.overline        = root.dataset.overline        || 'Fragrance Finder';
    el.heading         = root.dataset.heading         || 'Which notes move you?';
    el.resultsHeading  = root.dataset.resultsHeading  || 'Your 3 Memo';
    el.restartLabel    = root.dataset.restartLabel    || 'Start again';
    el.ctaUrl          = root.dataset.ctaUrl          || '';
    el.ctaLabel        = root.dataset.ctaLabel        || 'Discover these fragrances';
    // Email capture (Klaviyo) — all config comes from data attributes because
    // {% javascript %} is compiled and cannot contain Liquid.
    el.emailEnabled = root.dataset.emailEnabled === '1';
    el.klaviyo = {
      company: root.dataset.klaviyoCompany || '',
      list:    root.dataset.klaviyoList    || '',
      source:  root.dataset.emailSource    || 'olfactive guide',
      guide:   root.dataset.guideName      || 'The Olfactive Guide',
      lang:    root.dataset.guideLang      || (document.documentElement.lang || 'en')
    };
    el.selected = [];
    var sid = root.dataset.sectionId || '';
    var descTpl = document.getElementById('ff-desc-' + sid);
    el.description = descTpl ? descTpl.innerHTML.trim() : '';
    var noteTpl = document.getElementById('ff-results-note-' + sid);
    el.resultsNote = noteTpl ? noteTpl.innerHTML.trim() : '<p>Not sure yet? Receive a free sample with your order to try before you commit.</p>';
    // Parse the products metafield JSON FIRST so el.products is available
    // when we build el.perfumes below. (build-id: og-fix-1)
    var productEl = document.getElementById('ff-products-' + sid);
    try { el.products = productEl ? JSON.parse(productEl.textContent) : {}; }
    catch (e) { el.products = {}; }
    // Locale-aware translations injected by Liquid via locales/{lang}.json
    var i18nEl = document.getElementById('ff-i18n-' + sid);
    var i18n = {};
    try { i18n = i18nEl ? JSON.parse(i18nEl.textContent || '{}') : {}; } catch (e) { i18n = {}; }
    // Build a localized FAMILIES copy (don't mutate the global so re-init stays clean)
    el.families = FAMILIES.map(function (f) {
      var t = i18n.families && i18n.families[f.id];
      return t ? { id: f.id, label: t.label || f.label, hint: t.hint || f.hint } : f;
    });
    // Notes come from the product metafield (auto-localized by Shopify) when
    // available — that's the single source of truth, edited per-product in the
    // admin. If the metafield is empty for a given product, fall back to the
    // hardcoded EN notes baked into PERFUMES. Taglines are NEVER translated.
    el.perfumes = buildPerfumesFromProducts(el.products);
    // UI strings
    el.t = {
      multipleChoices: i18n.multipleChoices || 'Multiple choices possible',
      familySingular:  i18n.familySingular  || 'family selected',
      familyPlural:    i18n.familyPlural    || 'families selected',
      forPreposition:  i18n.forPreposition  || 'For',
      match:           i18n.match           || 'Match',
      revealAria:      i18n.revealAria      || 'Reveal my fragrances',
      email:           i18n.email            || {}
    };
    el._buildVersion = 'og-fix-1-2026-04-29';
    el._render();
  }

  FragranceFinder.prototype._render = function () {
    var self = this;
    if (self.variant === 'b') {
      self.root.innerHTML = '<div class="ff-inner"><div class="ff-widget ff-b"><div class="ff-b-left" data-ff-quiz></div><div class="ff-b-right" data-ff-side></div></div></div>';
      self.quizEl = self.root.querySelector('[data-ff-quiz]');
      self.sideEl = self.root.querySelector('[data-ff-side]');
      self._renderQuiz();
      self.sideEl.innerHTML = placeholderHTML();
    } else {
      self.root.innerHTML = '<div class="ff-inner"><div class="ff-widget ff-' + self.variant + '" data-ff-inner></div></div>';
      self.innerEl = self.root.querySelector('[data-ff-inner]');
      self._renderQuiz();
    }
  };

  FragranceFinder.prototype._renderQuiz = function () {
    var self = this;
    var container = self.variant === 'b' ? self.quizEl : self.innerEl;
    container.innerHTML = quizHTML(self.overline, self.heading, self.description, self.selected, self.families, self.t);
    container.querySelector('[data-ff-submit]').addEventListener('click', function () { self._submit(); });
    container.querySelectorAll('.ff-card').forEach(function (card) {
      card.addEventListener('click', function () { self._toggle(card.dataset.familyId); });
    });
  };

  FragranceFinder.prototype._toggle = function (id) {
    var idx = this.selected.indexOf(id);
    if (idx === -1) { this.selected.push(id); } else { this.selected.splice(idx, 1); }
    this._updateQuizState();
  };

  FragranceFinder.prototype._updateQuizState = function () {
    var self = this;
    var container = self.variant === 'b' ? self.quizEl : self.innerEl;
    container.querySelectorAll('.ff-card').forEach(function (card) {
      var on = self.selected.indexOf(card.dataset.familyId) !== -1;
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-pressed', String(on));
      var icon = card.querySelector('.ff-card-check-icon');
      if (icon) icon.style.opacity = on ? '1' : '0';
    });
    var count = self.selected.length;
    var countEl = container.querySelector('.ff-count');
    if (countEl) countEl.innerHTML = '<strong>' + count + '</strong> ' + (count === 1 ? self.t.familySingular : self.t.familyPlural);
    var btn = container.querySelector('[data-ff-submit]');
    if (btn) btn.disabled = count === 0;
  };

  FragranceFinder.prototype._submit = function () {
    var self = this;
    var matches = computeMatches(self.selected, 3, self.perfumes);
    var needed = matches.filter(function (m) { return !self.products[m.handle]; });
    if (needed.length === 0) {
      self._showResults(matches);
      return;
    }
    var done = 0;
    needed.forEach(function (m) {
      fetch('/products/' + m.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) {
            self.products[m.handle] = {
              url: '/products/' + m.handle,
              image: p.images && p.images[0] ? p.images[0].src.replace(/_([\d]+x[\d]*)\./, '_400x.') : '',
              title: p.title
            };
          }
        })
        .catch(function () {})
        .then(function () {
          done++;
          if (done === needed.length) self._showResults(matches);
        });
    });
  };

  FragranceFinder.prototype._showResults = function (matches) {
    var self = this;
    var html = resultsHTML(self.overline, self.selected, matches, self.ctaUrl, self.ctaLabel, self.products, self.variant === 'b', self.resultsHeading, self.restartLabel, self.resultsNote, self.families, self.t);
    var container = self.variant === 'b' ? self.sideEl : self.innerEl;
    container.innerHTML = html;
    var restartBtn = container.querySelector('[data-ff-restart]');
    if (restartBtn) restartBtn.addEventListener('click', function () { self._restart(); });
    if (self.emailEnabled && matches.length) self._mountEmailCapture(container, matches);
    // Scroll to the top of the widget after results render. Important on mobile,
    // where the user has just tapped the reveal button at the bottom of the quiz —
    // they would otherwise stay anchored at the bottom and miss the results header.
    try {
      var rect = self.root.getBoundingClientRect();
      var top = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    } catch (e) {}
  };

  FragranceFinder.prototype._mountEmailCapture = function (container, matches) {
    var self = this;
    var wrap = document.createElement('div');
    wrap.innerHTML = emailBlockHTML(self.t);
    var node = wrap.firstChild;
    var foot = container.querySelector('.ff-results-foot');
    if (foot) { container.insertBefore(node, foot); } else { container.appendChild(node); }

    var form  = node.querySelector('.ff-email-form');
    var input = node.querySelector('.ff-email-input');
    var btn   = node.querySelector('.ff-email-btn');
    var msg   = node.querySelector('.ff-email-msg');
    var e     = self.t.email || {};

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = (input.value || '').trim();
      msg.classList.remove('is-error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.textContent = e.invalid || 'Please enter a valid email address.';
        msg.classList.add('is-error');
        msg.hidden = false;
        return;
      }
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      msg.hidden = true;

      var perfumes = matches.map(function (m) {
        var pd = self.products[m.handle] || {};
        return {
          name:    pd.title || m.name,
          handle:  m.handle,
          url:     absoluteUrl(pd.url || ('/products/' + m.handle)),
          image:   absoluteUrl(pd.image || ''),
          notes:   m.notes || '',
          tagline: m.tagline || '',
          match:   m.match
        };
      });
      var families = self.selected.map(function (id) {
        var f = self.families.filter(function (x) { return x.id === id; })[0];
        return f ? f.label : id;
      });

      sendResultsToKlaviyo(self.klaviyo, email, perfumes, families)
        .then(function () {
          node.classList.add('is-done');
          msg.textContent = e.success || 'It is on its way. Have a look at your inbox.';
          msg.hidden = false;
        })
        .catch(function (err) {
          if (window.console) console.error('[olfactive-guide] klaviyo', err);
          btn.disabled = false;
          btn.textContent = label;
          msg.textContent = e.error || 'Something went wrong. Please try again.';
          msg.classList.add('is-error');
          msg.hidden = false;
        });
    });
  };

  FragranceFinder.prototype._restart = function () {
    this.selected = [];
    this._render();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ff-root]').forEach(function (el) {
      if (!el.dataset.ffInit) {
        el.dataset.ffInit = '1';
        new FragranceFinder(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ff-root]');
    if (root) { delete root.dataset.ffInit; new FragranceFinder(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
